/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Trackermodal_Signinprompt3Inputs */

const he_extension_trackermodal_signinprompt3 = /** @type {(inputs: Extension_Trackermodal_Signinprompt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחבר/י ל-pricedrop כדי לעקוב אחרי המוצר הזה`)
};

const en_extension_trackermodal_signinprompt3 = /** @type {(inputs: Extension_Trackermodal_Signinprompt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to PriceDrop to track this item`)
};

/**
* | output |
* | --- |
* | "Sign in to PriceDrop to track this item" |
*
* @param {Extension_Trackermodal_Signinprompt3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_trackermodal_signinprompt3 = /** @type {((inputs?: Extension_Trackermodal_Signinprompt3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Trackermodal_Signinprompt3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_trackermodal_signinprompt3(inputs)
	return en_extension_trackermodal_signinprompt3(inputs)
});
export { extension_trackermodal_signinprompt3 as "extension_trackerModal_signInPrompt" }